(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[734],{

/***/ 86819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles-v2/[...name]",
      function () {
        return __webpack_require__(23360);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PersonInline; },
/* harmony export */   "N": function() { return /* binding */ PersonWithBio; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72752);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4796);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core_Icon_Icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49154);
/* harmony import */ var _opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87583);
/* harmony import */ var _opendoor_bricks_core_Icon_SpritesheetIcons_NewTab__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42141);
/* harmony import */ var components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90516);
/* harmony import */ var _helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58699);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43613);











// Person component, with a place for extra text (i.e. passed in as children)
var PersonInline = function(props) {
    if (!props.person) {
        return null;
    }
    var _fields = props.person.fields, _firstName = _fields.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = _fields.lastName, lastName = _lastName === void 0 ? "" : _lastName, _picture = _fields.picture, picture = _picture === void 0 ? "" : _picture, credential = _fields.credential, displayName = _fields.displayName;
    var initials = firstName.charAt(0) + lastName.charAt(0);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        alignSelf: "flex-start",
        alignItems: "center",
        children: [
            picture && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                display: [
                    "none",
                    null,
                    null,
                    "initial"
                ],
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .q, {
                    size: "lg",
                    src: picture,
                    initials: initials
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                marginLeft: [
                    "0",
                    null,
                    null,
                    picture ? "4" : "0"
                ],
                marginBottom: "0",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                        marginBottom: 0,
                        mt: "0",
                        children: [
                            displayName,
                            credential && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: ",\xa0"
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "i"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        fontWeight: "regular",
                                        margin: "0",
                                        children: credential
                                    }))
                                ]
                            })
                        ]
                    })),
                    props.children
                ]
            })
        ]
    }, firstName + lastName);
};
var PersonWithBio = function(props) {
    var _fields = props.person.fields, _firstName = _fields.firstName, firstName = _firstName === void 0 ? "" : _firstName, _lastName = _fields.lastName, lastName = _lastName === void 0 ? "" : _lastName, _picture = _fields.picture, picture = _picture === void 0 ? "" : _picture, displayName = _fields.displayName, _bio = _fields.bio, bio = _bio === void 0 ? "" : _bio, _website = _fields.website, website = _website === void 0 ? "" : _website, _twitterUsername = _fields.twitterUsername, twitterUsername = _twitterUsername === void 0 ? "" : _twitterUsername, _instagramUsername = _fields.instagramUsername, instagramUsername = _instagramUsername === void 0 ? "" : _instagramUsername, _linkedInUsername = _fields.linkedInUsername, linkedInUsername = _linkedInUsername === void 0 ? "" : _linkedInUsername;
    var initials = firstName.charAt(0) + lastName.charAt(0);
    var renderLink = function(url, iconComponent) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            "aria-label": "",
            href: url,
            target: "_blank",
            analyticsName: "",
            display: "flex",
            alignItems: "center",
            opacity: "0.2",
            _hover: {
                opacity: "1.0"
            },
            children: iconComponent
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core_Icon_SelectiveSpritesheet__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                icons: [
                    _opendoor_bricks_core_Icon_SpritesheetIcons_NewTab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                flexDirection: "column",
                marginBottom: 4,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_complex__WEBPACK_IMPORTED_MODULE_4__/* .Avatar */ .q, {
                        size: "lg",
                        src: picture,
                        initials: initials
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        marginTop: 4,
                        flexWrap: "wrap",
                        gridColumnGap: "4",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: displayName
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "span"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        children: ",\xa0"
                                    })),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        as: "i"
                                    }, _typography__WEBPACK_IMPORTED_MODULE_0__/* ["default"].authorName */ .Z.authorName), {
                                        fontWeight: "regular",
                                        children: props.roleText
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                gridGap: "4",
                                display: "inline-flex",
                                marginBottom: 2,
                                children: [
                                    twitterUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("twitter", twitterUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "twitter"
                                    })),
                                    instagramUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("instagram", instagramUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "instagram"
                                    })),
                                    linkedInUsername && renderLink((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_11__/* .getSocialLink */ .a)("linkedin", linkedInUsername), /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_shared_icons_SocialIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        socialPlatform: "linkedin"
                                    })),
                                    website && renderLink(website, /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core_Icon_Icon__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        name: "new-tab",
                                        size: 16
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        size: "s1",
                        marginTop: 0,
                        children: bio
                    })
                ]
            }, firstName + lastName)
        ]
    });
};



/***/ }),

/***/ 92474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArticleSchemaData */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58699);



var getBaseTags = function(props) {
    if (!props.base || !props.base.fields) {
        return null;
    }
    var _fields = props.base.fields, canonicalUrl = _fields.canonicalUrl, metaDescription = _fields.metaDescription, title = _fields.title;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
            children: title
        }, "title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "description",
            content: metaDescription
        }, "description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("link", {
            rel: "canonical",
            href: canonicalUrl
        }, "canonical"), 
    ];
};
var getOgTags = function(props) {
    if (!props.og || !props.ogArticle || !props.og.fields || !props.ogArticle.fields) {
        return null;
    }
    var _fields = props.og.fields, url = _fields.url, type = _fields.type, title = _fields.title, description = _fields.description, image = _fields.image, siteName = _fields.siteName;
    // TODO: may need to double check what time format these are in
    var _fields1 = props.ogArticle.fields, _publishedTime = _fields1.// fallback to article created at and updated at if not explicitly
    // provided
    publishedTime, publishedTime = _publishedTime === void 0 ? props.createdAt : _publishedTime, _modifiedTime = _fields1.modifiedTime, modifiedTime = _modifiedTime === void 0 ? props.updatedAt : _modifiedTime, expirationDate = _fields1.expirationDate, section = _fields1.section, tags = _fields1.tags;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:title",
            content: title
        }, "og:title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:type",
            content: type
        }, "og:type"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:url",
            content: url
        }, "og:url"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:image",
            content: image
        }, "og:image"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:description",
            content: description
        }, "og:description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:site_name",
            content: siteName
        }, "og:site_name"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:published_time",
            content: publishedTime
        }, "og:article:published_time"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:modified_time",
            content: modifiedTime
        }, "og:article:modified_time"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:section",
            content: section
        }, "og:article:section"),
        expirationDate && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            property: "og:article:expiration_time",
            content: expirationDate
        }, "og:article:expiration_time"),
        (props.authors || []).map(function(author) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:article:author",
                content: author.fields.displayName
            }, author.fields.displayName);
        }),
        (tags || []).map(function(tag) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:article:tag",
                content: tag
            }, tag);
        }), 
    ];
};
var getTwitterTags = function(props) {
    if (!props.card || !props.card.fields) {
        return null;
    }
    var _fields = props.card.fields, cardType = _fields.cardType, site = _fields.site, creatorTwitterHandle = _fields.creatorTwitterHandle, description = _fields.description, image = _fields.image, title = _fields.title;
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:card",
            content: cardType
        }, "twitter:card"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:site",
            content: site
        }, "twitter:site"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:creator",
            content: creatorTwitterHandle
        }, "twitter:creator"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:title",
            content: title
        }, "twitter:title"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:description",
            content: description
        }, "twitter:description"),
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "twitter:image",
            content: image
        }, "twitter:image"), 
    ];
};
var getCrawlerTags = function(props) {
    var follow = props.follow, index = props.index;
    if (follow && index) {
        return null;
    }
    return [
        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
            name: "robots",
            content: [
                !follow && "nofollow",
                !index && "noindex"
            ].filter(Boolean).join(",")
        }, "robots"), 
    ];
};
// Export only for testing
var getArticleSchemaData = function(param) {
    var slug = param.slug, title = param.title, subtitle = param.subtitle, description = param.description, _authors = param.authors, authors = _authors === void 0 ? [] : _authors, editors = param.editors, reviewers = param.reviewers, image = param.image, publisher = param.publisher, createdAt = param.createdAt, updatedAt = param.updatedAt, tags = param.tags, section = param.section;
    var canonicalUrl = "https://www.opendoor.com".concat(slug);
    // Normalize dates to ISO 8601 datetime format
    // publishDate from Contentful is date-only, sys timestamps are full datetime
    var normalizedPublishedDate = createdAt.includes("T") ? createdAt : "".concat(createdAt, "T00:00:00.000Z");
    var schemaData = {
        "@context": "https://schema.org",
        "@type": "Article",
        "@id": canonicalUrl,
        mainEntityOfPage: canonicalUrl,
        dateModified: updatedAt,
        datePublished: normalizedPublishedDate,
        // TODO: use custom image for each article page
        image: [
            image,
            "https://images.opendoor.com/source/s3/imgdrop-production/1afd9b4404c54cd5bd4d3737eec0d70d.jpg?preset=square-2048", 
        ].filter(Boolean),
        inLanguage: "en-US"
    };
    if (title) schemaData.headline = title;
    if (subtitle) schemaData.alternativeHeadline = subtitle;
    if (description) schemaData.description = description;
    if (tags && tags.length > 0) schemaData.keywords = tags;
    if (section) schemaData.about = {
        "@type": "Thing",
        name: section
    };
    // Map authors to Person schema
    var authorPersons = authors.map(function(author) {
        var sameAs = [];
        if (author.twitterUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("twitter", author.twitterUsername));
        }
        if (author.linkedInUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", author.linkedInUsername));
        }
        if (author.instagramUsername) {
            sameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("instagram", author.instagramUsername));
        }
        var url = author.website || (sameAs === null || sameAs === void 0 ? void 0 : sameAs[0]);
        var person = {
            "@type": "Person",
            name: author.displayName
        };
        if (url) person.url = url;
        if (sameAs.length > 0) person.sameAs = sameAs;
        return person;
    });
    if (reviewers && reviewers.length > 0) {
        reviewers.forEach(function(reviewer) {
            var reviewerPerson = {
                "@type": "Person",
                name: reviewer.displayName
            };
            if (reviewer.linkedInUsername) {
                reviewerPerson.sameAs = (0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", reviewer.linkedInUsername);
            }
            authorPersons.push(reviewerPerson);
        });
    }
    if (authorPersons.length > 0) {
        schemaData.author = authorPersons;
    }
    if (editors && editors.length > 0) {
        var editor = editors[0];
        var editorPerson = {
            "@type": "Person",
            name: editor.displayName
        };
        if (editor.linkedInUsername) {
            editorPerson.sameAs = (0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("linkedin", editor.linkedInUsername);
        }
        schemaData.editor = editorPerson;
    }
    if (publisher) {
        var publisherSameAs = [];
        if (publisher.twitterUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("twitter", publisher.twitterUsername));
        }
        if (publisher.linkedInUsername) {
            publisherSameAs.push("https://www.linkedin.com/company/".concat(publisher.linkedInUsername));
        }
        if (publisher.instagramUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("instagram", publisher.instagramUsername));
        }
        if (publisher.youtubeChannel) {
            publisherSameAs.push("https://www.youtube.com/c/".concat(publisher.youtubeChannel));
        }
        if (publisher.facebookUsername) {
            publisherSameAs.push((0,_helpers_socialLinks__WEBPACK_IMPORTED_MODULE_2__/* .getSocialLink */ .a)("facebook", publisher.facebookUsername));
        }
        var publisherUrl = publisher.url || (publisherSameAs === null || publisherSameAs === void 0 ? void 0 : publisherSameAs[0]);
        var publisherOrg = {
            "@type": "Organization",
            name: publisher.name
        };
        if (publisherUrl) publisherOrg.url = publisherUrl;
        if (publisherSameAs.length > 0) publisherOrg.sameAs = publisherSameAs;
        if (publisher.logoUrl) {
            publisherOrg.logo = {
                "@type": "ImageObject",
                url: publisher.logoUrl
            };
        }
        schemaData.publisher = publisherOrg;
    }
    return schemaData;
};
var SeoHead = function(param) {
    var slug = param.slug, articleName = param.articleName, articleSubtitle = param.articleSubtitle, headerSummary = param.headerSummary, base = param.base, _authors = param.authors, authors = _authors === void 0 ? [] : _authors, _editors = param.editors, editors = _editors === void 0 ? [] : _editors, _reviewers = param.reviewers, reviewers = _reviewers === void 0 ? [] : _reviewers, og = param.og, ogArticle = param.ogArticle, twitterCard = param.twitterCard, sys = param.sys, publisher = param.publisher, publishDate = param.publishDate;
    // ensure that you don't nest tags inside of fragments
    // if you do that, then the next head component
    // will have issues with overrides
    var fields = (base === null || base === void 0 ? void 0 : base.fields) || {};
    var _index, _follow;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            getBaseTags({
                base: base
            }),
            getOgTags({
                og: og,
                ogArticle: ogArticle,
                createdAt: sys.createdAt,
                updatedAt: sys.updatedAt,
                authors: authors
            }),
            getTwitterTags({
                card: twitterCard
            }),
            getCrawlerTags({
                index: (_index = fields.index) !== null && _index !== void 0 ? _index : true,
                follow: (_follow = fields.follow) !== null && _follow !== void 0 ? _follow : true
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getArticleSchemaData({
                        slug: slug,
                        title: fields.title || articleName,
                        subtitle: articleSubtitle,
                        description: headerSummary || fields.metaDescription,
                        authors: authors.map(function(author) {
                            return author.fields;
                        }),
                        editors: editors.map(function(editor) {
                            return editor.fields;
                        }),
                        reviewers: reviewers.map(function(reviewer) {
                            return reviewer.fields;
                        }),
                        image: og === null || og === void 0 ? void 0 : og.fields.image,
                        publisher: publisher === null || publisher === void 0 ? void 0 : publisher.fields,
                        createdAt: publishDate || sys.createdAt,
                        updatedAt: sys.updatedAt,
                        tags: ogArticle === null || ogArticle === void 0 ? void 0 : ogArticle.fields.tags,
                        section: ogArticle === null || ogArticle === void 0 ? void 0 : ogArticle.fields.section
                    }))
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoHead);


/***/ }),

/***/ 23360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Link/Link.mjs
var Link = __webpack_require__(47208);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Image/Image.mjs
var Image_Image = __webpack_require__(61442);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/helpers/socialLinks.ts
var socialLinks = __webpack_require__(58699);
// EXTERNAL MODULE: ./src/components/articles-v2/Person.tsx
var Person = __webpack_require__(95278);
;// CONCATENATED MODULE: ./src/components/articles-v2/util.ts

var camelToTitleCase = function(str) {
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function(char) {
        return char.toUpperCase();
    }).trim();
};
var EXCLUDE_TAGS = [
    "blog",
    "guide"
];
// nb tags may be alike 'homeBuyingTips'
var getArticleCategory = function(tags) {
    var categoryTag = tags === null || tags === void 0 ? void 0 : tags.find(function(tag) {
        return !EXCLUDE_TAGS.includes(tag);
    });
    if (!categoryTag) {
        return "";
    }
    return camelToTitleCase(categoryTag);
};
var articleTopicEnvRoot = globals/* COSMOS_URL */.EQ + "/articles" + (globals/* DEPLOY_ENV */.Zp === "production" ? "" : "-v2") + "/topic";

;// CONCATENATED MODULE: ./src/components/articles-v2/ArticleHeader.tsx







var ArticleCategoryBreadcrumbLink = {
    "Company News": "/company-news",
    "Home Buying Tips": "/moving-trends-insights",
    Sellers: "/sell",
    Buyers: "/buy",
    Agents: "/agent"
};
var ArticleHeader = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var articleCategory = getArticleCategory(props.sys.tags);
    // Only articles after the contentful migration will have a header image
    var headerImgUrl = (ref2 = (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.headerImage) === null || ref1 === void 0 ? void 0 : ref1.fields.file) === null || ref2 === void 0 ? void 0 : ref2.url;
    var headerImgAlt = ((ref3 = props.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.headerImage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fields) === null || ref5 === void 0 ? void 0 : ref5.description) || ((ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.headerImage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.title);
    // Enumerate author/reviewer field props for readability
    var author = (ref9 = props.fields.authors) === null || ref9 === void 0 ? void 0 : ref9[0];
    var reviewer = (ref10 = props.fields.reviewers) === null || ref10 === void 0 ? void 0 : ref10[0];
    var ref12 = (author === null || author === void 0 ? void 0 : author.fields) || {}, authorDescription = ref12.description, authorContact = ref12.contact, authorLinkedIn = ref12.linkedInUsername, authorDisplayName = ref12.displayName;
    var ref13 = (reviewer === null || reviewer === void 0 ? void 0 : reviewer.fields) || {}, reviewerDescription = ref13.description, reviewerContact = ref13.contact, reviewerLinkedIn = ref13.linkedInUsername, reviewerDisplayName = ref13.displayName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                marginBottom: "$32x",
                $largerThanSM: {
                    marginBottom: 90,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    columnGap: "$12x"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            flexGrow: 12,
                            flexShrink: 1,
                            flexBasis: 12
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$labelMedium",
                                marginBottom: "$12x",
                                display: "flex",
                                alignItems: "center",
                                columnGap: "$3x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: globals/* COSMOS_URL */.EQ,
                                        "aria-label": "Home",
                                        analyticsName: "article-header-breadcrumb-home",
                                        children: "Home"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: ">"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: globals/* COSMOS_URL */.EQ + "/newsroom",
                                        "aria-label": "Newsroom",
                                        analyticsName: "article-header-breadcrumb-newsroom",
                                        children: "Newsroom"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: ">"
                                    }),
                                    (ArticleCategoryBreadcrumbLink === null || ArticleCategoryBreadcrumbLink === void 0 ? void 0 : ArticleCategoryBreadcrumbLink[articleCategory]) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: articleTopicEnvRoot + ArticleCategoryBreadcrumbLink[articleCategory],
                                        "aria-label": articleCategory,
                                        analyticsName: "article-header-breadcrumb-article-category",
                                        children: articleCategory
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        children: articleCategory
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h1",
                                typography: "$headerLarge",
                                $largerThanSM: {
                                    typography: "$displayMedium"
                                },
                                children: props.fields.articleName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        paddingLeft: "$36x",
                        display: "none",
                        $largerThanSM: {
                            display: "block"
                        },
                        children: [
                            !props.fields.hideReadingTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$labelMedium",
                                marginBottom: "$20x",
                                children: [
                                    "Reading Time — ",
                                    props.readingTimeMinutes,
                                    " minutes"
                                ]
                            }),
                            props.fields.publishDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$bodyMedium",
                                marginBottom: "$4x",
                                children: [
                                    "Publication date:",
                                    " ",
                                    new Date(props.fields.publishDate + "T00:00:00").toLocaleDateString("en-us", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric"
                                    })
                                ]
                            }),
                            props.fields.actualizationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                color: "$contentSecondary",
                                typography: "$bodyMedium",
                                children: [
                                    "Actualization Date:",
                                    " ",
                                    new Date(props.fields.actualizationDate + "T00:00:00").toLocaleDateString("en-us", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $largerThanSM: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    columnGap: "$16x"
                },
                marginBottom: props.fields.keyTakeaways && ((ref11 = props.fields.keyTakeaways) === null || ref11 === void 0 ? void 0 : ref11.content.length) > 0 ? "$32x" : 0,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        marginBottom: "$32x",
                        $largerThanSM: {
                            marginBottom: 0,
                            flexGrow: 4,
                            flexShrink: 1,
                            flexBasis: "20%"
                        },
                        children: [
                            props.fields.articleSubtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$headerSmall",
                                marginBottom: "$8x",
                                children: props.fields.articleSubtitle
                            }),
                            author && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        marginBottom: "$2x",
                                        children: "Author"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person/* PersonInline */.E, {
                                        person: author
                                    })
                                ]
                            }),
                            authorDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    children: authorDescription
                                })
                            }),
                            authorContact && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "Contact:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "mailto:".concat(authorContact),
                                        "aria-label": "Email ".concat(authorDisplayName || "author"),
                                        analyticsName: "article-header-author-email",
                                        children: authorContact
                                    })
                                ]
                            }),
                            reviewer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                marginTop: "$8x",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelMedium",
                                        color: "$contentSecondary",
                                        marginBottom: "$2x",
                                        children: "Reviewer"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person/* PersonInline */.E, {
                                        person: reviewer
                                    })
                                ]
                            }),
                            reviewerDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    children: reviewerDescription
                                })
                            }),
                            reviewerContact && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "Contact:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "mailto:".concat(reviewerContact),
                                        "aria-label": "Email ".concat(reviewerDisplayName || "reviewer"),
                                        analyticsName: "article-header-reviewer-email",
                                        children: reviewerContact
                                    })
                                ]
                            }),
                            authorLinkedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "LinkedIn:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: (0,socialLinks/* getSocialLink */.a)("linkedin", authorLinkedIn),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "LinkedIn profile for ".concat(authorDisplayName || "author"),
                                        analyticsName: "article-header-author-linkedin",
                                        children: authorLinkedIn
                                    })
                                ]
                            }),
                            reviewerLinkedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelMedium",
                                        children: "LinkedIn:\xa0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: (0,socialLinks/* getSocialLink */.a)("linkedin", reviewerLinkedIn),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "LinkedIn profile for ".concat(reviewerDisplayName || "reviewer"),
                                        analyticsName: "article-header-reviewer-linkedin",
                                        children: reviewerLinkedIn
                                    })
                                ]
                            })
                        ]
                    }),
                    headerImgUrl && headerImgAlt && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "header-image",
                        marginBottom: 32,
                        $largerThanSM: {
                            marginBottom: 0,
                            flexGrow: 8,
                            flexShrink: 1,
                            flexBasis: "50%"
                        },
                        minWidth: 0,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image_Image/* default */.Z, {
                            src: headerImgUrl,
                            alt: headerImgAlt,
                            borderRadius: "roundedSmooth",
                            w: "100%",
                            h: "auto"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        children: [
                            !props.fields.hideReadingTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                marginBottom: "$8x",
                                children: [
                                    "Reading Time — ",
                                    props.readingTimeMinutes,
                                    " minutes"
                                ]
                            }),
                            props.fields.publishDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                marginBottom: "$4x",
                                children: new Date(props.fields.publishDate + "T00:00:00").toLocaleDateString("en-us", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric"
                                })
                            }),
                            props.fields.actualizationDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentSecondary",
                                children: new Date(props.fields.actualizationDate + "T00:00:00").toLocaleDateString("en-us", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/fontTokens.js
var fontTokens = __webpack_require__(10533);
;// CONCATENATED MODULE: ./src/components/articles-v2/constants.ts


/* These styles are added as they have to be applied to the dynamic contents from contentful child nodes, 
so have to inject them as inline css
*/ var ArticleContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efd38so0"
})("width:100%;max-width:1440px;padding:64px 24px;margin:auto;> p,> ul,> ol,> blockquote,> hr,> table{grid-column:5 / -2;margin-bottom:0;}> h1,> h2,> h3,> h4{grid-column:4 / -2;margin-bottom:0;}> div{grid-column:1 / -1;margin-bottom:0;}hr{background-color:", (0,cjs.getToken)("$backgroundStateHoverSecondary"), ";border:none;grid-column:2 / -2;height:1px;margin-inline:auto;width:100%;}> * + *{margin-top:", (0,cjs.getToken)("$12x"), " !important;}> h1 + *,> h2 + *,> h3 + *,> h4 + *,> * + h1,> * + h2,> * + h3,> * + h4,> * + .embedded-entry-wrapper,> .embedded-entry-wrapper + *,> * + hr,> hr + *{margin-top:", (0,cjs.getToken)("$24x"), " !important;}@media (min-width:768px){display:grid;}");
var ArticleHeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efd38so1"
})("> * + *{margin-top:24px;}> p:first-child{font-size:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "size"), ";letter-spacing:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "letterSpacing"), ";line-height:", (0,fontTokens/* getTypographyCSSVariable */.Pp)("$subheaderSmall", "lineHeight"), ";}> p:first-child + *{margin-top:", (0,cjs.getToken)("$32x"), ";}ul{list-style:none;margin-left:0;padding-left:0;}a,a:visited{color:", (0,cjs.getToken)("$contentPrimary"), ";}a:hover{color:", (0,cjs.getToken)("$backgroundAccentBrand"), ";}");


// EXTERNAL MODULE: ./src/components/articles-v2/seo/index.tsx
var seo = __webpack_require__(92474);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(21076);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx + 1 modules
var StickyCTAUtility = __webpack_require__(97661);
// EXTERNAL MODULE: ./src/pages/shared/LandingPageV2Layout.tsx + 6 modules
var LandingPageV2Layout = __webpack_require__(66131);
// EXTERNAL MODULE: ./src/cms/entries/articleV2.ts + 15 modules
var articleV2 = __webpack_require__(18834);
// EXTERNAL MODULE: ./src/components/articles-v2/renderer.tsx
var renderer = __webpack_require__(818);
;// CONCATENATED MODULE: ./src/pages/articles-v2/[...name].tsx















var MAX_WIDTH = 1440;
var HEADER_HEIGHT = 65;
var Article = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref8 = (0,HeroShared/* useStickyCTA */.AJ)(), addressEntryRef = ref8.addressEntryRef, showStickyCTAUtility = ref8.showStickyCTAUtility;
    var hideStickyCta = authentication.state === "authenticated";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LandingPageV2Layout["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                slug: props.fields.slug,
                articleName: props.fields.articleName,
                articleSubtitle: props.fields.articleSubtitle,
                headerSummary: props.fields.headerSummary,
                og: props.fields.openGraph,
                ogArticle: props.fields.openGraphArticle,
                base: props.fields.seoBase,
                authors: props.fields.authors,
                editors: props.fields.editors,
                reviewers: props.fields.reviewers,
                twitterCard: props.fields.twitterCard,
                sys: props.sys,
                publisher: props.fields.publisher,
                publishDate: props.fields.publishDate
            }),
            !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                analyticsId: "article-detail",
                isVisible: showStickyCTAUtility,
                style: {
                    top: "80px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "article",
                backgroundColor: "$backgroundSecondary",
                marginTop: HEADER_HEIGHT,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        backgroundColor: "$backgroundPrimary",
                        paddingVertical: 64,
                        paddingHorizontal: 24,
                        borderBottomRightRadius: 64,
                        borderBottomLeftRadius: 64,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            ref: function(el) {
                                return addressEntryRef(el);
                            },
                            maxWidth: MAX_WIDTH,
                            marginHorizontal: "auto",
                            width: "100%",
                            $largerThanSM: {
                                paddingHorizontal: "$10x"
                            },
                            $largerThanMD: {
                                paddingHorizontal: "$20x"
                            },
                            $largerThanLG: {
                                paddingHorizontal: "$32x"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeader, (0,_object_spread/* default */.Z)({}, props)),
                                props.fields.keyTakeaways && ((ref = props.fields.keyTakeaways) === null || ref === void 0 ? void 0 : ref.content.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        $largerThanSM: {
                                            marginLeft: "calc((4 * 1/12) * 100%)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "p",
                                                typography: "$bodyMedium",
                                                marginBottom: "$8x",
                                                children: "Summary"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleHeaderContainer, {
                                                className: "font_body",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                                                    body: props.fields.keyTakeaways,
                                                    idToLoaderData: props.idToLoaderData,
                                                    entryLookup: articleV2/* default */.Z
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArticleContainer, {
                        style: {
                            gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                            body: props.fields.body,
                            idToLoaderData: props.idToLoaderData,
                            entryLookup: articleV2/* default */.Z
                        })
                    }),
                    props.fields.showAuthorFooter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        justifyContent: "center",
                        flexDirection: "row",
                        marginBottom: 64,
                        paddingHorizontal: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            $largerThanSM: {
                                flexDirection: "row"
                            },
                            alignItems: "center",
                            columnGap: "$8x",
                            rowGap: "$16x",
                            children: [
                                ((ref1 = props.fields.authors) === null || ref1 === void 0 ? void 0 : ref1[0].fields.picture) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    height: 96,
                                    width: 96,
                                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("flex-shrink:0;"),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                        source: {
                                            uri: (ref2 = props.fields.authors) === null || ref2 === void 0 ? void 0 : ref2[0].fields.picture
                                        },
                                        alt: "Photo of ".concat((ref3 = props.fields.authors) === null || ref3 === void 0 ? void 0 : ref3[0].fields.displayName),
                                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("object-fit:cover;width:100%;height:100%;border-radius:50%;")
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$subheaderXsmall",
                                            $largerThanSM: {
                                                typography: "$subheaderSmall"
                                            },
                                            marginBottom: "$4x",
                                            children: ((ref4 = props.fields.authors) === null || ref4 === void 0 ? void 0 : ref4[0].fields.displayName) && ((ref5 = props.fields.authors) === null || ref5 === void 0 ? void 0 : ref5[0].fields.displayName)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$subheaderXsmall",
                                            $largerThanSM: {
                                                typography: "$subheaderSmall"
                                            },
                                            children: ((ref6 = props.fields.authors) === null || ref6 === void 0 ? void 0 : ref6[0].fields.bio) && ((ref7 = props.fields.authors) === null || ref7 === void 0 ? void 0 : ref7[0].fields.bio)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
var __N_SSP = true;
/* harmony default export */ var _name_ = (Article);


/***/ }),

/***/ 42141:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
function cov_2aeau7yxor() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx";
  var hash = "fd7172e4b020de994de21291bf9b33d5c136fd04";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/NewTab.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "fd7172e4b020de994de21291bf9b33d5c136fd04"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aeau7yxor = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2aeau7yxor();
var Icon = (cov_2aeau7yxor().s[0]++, {
  name: 'new-tab',
  svg: "<path d=\"M21.9498 10.0267L22.0065 1.98876L13.1912 2.05015C12.5008 2.05496 11.9451 2.61849 11.9499 3.30882C11.9547 3.99916 12.5182 4.5549 13.2086 4.55009L17.4399 4.52062L10.1161 11.8444C9.6279 12.3326 9.6279 13.1241 10.1161 13.6122C10.6042 14.1004 11.3957 14.1004 11.8838 13.6122L19.478 6.01801L19.4499 10.0091C19.445 10.6994 20.0007 11.263 20.6911 11.2678C21.3814 11.2727 21.945 10.717 21.9498 10.0267Z\" fill=\"currentColor\"/>\n  <path d=\"M4.44995 7.25H9.19995C9.89031 7.25 10.45 6.69035 10.45 6C10.45 5.30964 9.89031 4.75 9.19995 4.75H4.19995C2.95731 4.75 1.94995 5.75736 1.94995 7V20C1.94995 21.2426 2.95731 22.25 4.19995 22.25H17.2C18.4426 22.25 19.45 21.2426 19.45 20V14C19.45 13.3096 18.8903 12.75 18.2 12.75C17.5096 12.75 16.95 13.3096 16.95 14V19.75H4.44995V7.25Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9842,2767,6500,5662,7166,3089,4638,9331,5569,523,5527,4897,6937,7014,7194,5369,5675,2864,8764,4746,5663,4370,7890,9593,2283,8058,2149,1462,5040,8834,6131,9774,2888,179], function() { return __webpack_exec__(86819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);